import { init } from '@sentry/react'

import 'polyfills' // should be first

if (process.env.SENTRY_DSN) {
  init({ dsn: process.env.SENTRY_DSN, environment: process.env.SENTRY_ENVIRONMENT })
}
